var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813",
    transform: "translate(-11141 24372)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    cx: 125,
    cy: 125,
    r: 125,
    transform: "translate(11141 -24372)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803",
    transform: "translate(10795.692 -24737.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M503.851,468.335v5.414c0,3.733-1.685,6.755-3.757,6.766H383.6c-2.072-.011-3.751-3.033-3.757-6.766v-5.414",
    transform: "translate(14.385 75.758)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M430.28,410.161a44.679,44.679,0,0,1,11.367,14.027s4.261,10.72,3.541,26.2-8.648,21.28-9.037,29.02-2.808,17.09,4.527,27.086,10.614,5.159,17.681,10.318,15.693,7.415,17.023,11.929a6.86,6.86,0,0,0,5.845,4.837l-5.845-14.187-11.89-7.093L450.433,505.2l-7.417-7.335.279-10.158,5.847-6.85,7.015-12.978,3.063-3.145-.645-12.171-.807-3.547-2.016-4.03-.725-13.221-1.854-7.657-7.5-9.513-9.513-4.434Z",
    transform: "translate(73.048 8.098)",
    fill: "#e2e5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M504.408,486.32H435a2.163,2.163,0,1,1,0-4.326h69.406a2.163,2.163,0,1,1,0,4.326Z",
    transform: "translate(76.024 91.644)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M461.029,486.32H391.623a2.163,2.163,0,1,1,0-4.326h69.406a2.163,2.163,0,1,1,0,4.326Z",
    transform: "translate(25.572 91.644)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M403.693,486.32H369.636a2.163,2.163,0,1,1,0-4.326h34.057a2.163,2.163,0,1,1,0,4.326Z",
    transform: "translate(0 91.644)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M501.26,558.436H384.76a5.751,5.751,0,0,1-5.918-5.518v-2.693c0-9.349,5.663-17.921,14.78-22.368L418.69,513.8a8.647,8.647,0,0,0,5.243-7.434v-9.587l-.359-.333a48.78,48.78,0,0,1-13.51-20.56l-.13-.4-.394-.3a10.379,10.379,0,0,1-4.4-8.419V455.189a10.1,10.1,0,0,1,3.519-7.205l.238-.229V431.975c.1-1.246,2.635-26.052,33.919-28.76l.186-.017.184.015c31.661,2.715,33.839,27.581,33.917,28.637l0,15.922.344.34a9.972,9.972,0,0,1,3.413,6.965l0,11.7a10.4,10.4,0,0,1-4.417,8.429l-.372.281-.128.389a48.733,48.733,0,0,1-13.528,20.581l-.346.322v9.636a8.531,8.531,0,0,0,5.122,7.32l25.3,14.175c9.026,4.376,14.694,12.95,14.67,22.318v2.682A5.752,5.752,0,0,1,501.26,558.436ZM443.007,407.541c-27.064,2.431-29.589,22.353-29.787,24.62l.009,17.43-1.64,1.579a5.853,5.853,0,0,0-2.12,4.123l0,11.486a6.122,6.122,0,0,0,2.65,4.94l1.506,1.131.549,1.689A44.415,44.415,0,0,0,426.5,493.263l1.756,1.631v11.525a12.873,12.873,0,0,1-7.575,11.22l-25.055,14.049c-7.731,3.775-12.461,10.854-12.461,18.537v2.689c0,.645.733,1.194,1.6,1.2H501.258c.859,0,1.59-.552,1.592-1.2v-2.691c.02-7.692-4.713-14.769-12.347-18.473l-25.293-14.17a12.77,12.77,0,0,1-7.456-11.112v-11.57l1.746-1.618a44.44,44.44,0,0,0,12.345-18.747l.545-1.681,1.486-1.114a6.133,6.133,0,0,0,2.669-4.949v-11.6a5.732,5.732,0,0,0-2.044-3.917l-1.715-1.7V432.008C472.725,431.259,470.856,410.022,443.007,407.541Z",
    transform: "translate(13.223 0)",
    fill: "#2f4265"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M479.541,541.654l-.006-4.326c.619,0,1.053-.379,1.053-.716v-2.3c.015-6.463-3.965-12.409-10.387-15.524l-21.652-12.13a11.231,11.231,0,0,1-6.537-9.771V486.849l1.592-1.477a37.668,37.668,0,0,0,10.476-15.905l.5-1.531,1.35-1.01a4.947,4.947,0,0,0,2.157-3.982v-9.922a4.6,4.6,0,0,0-1.64-3.113l-1.575-1.568V433.19c-.05-.606-1.646-18.6-25.349-20.631l.372-4.311c27.335,2.345,29.229,23.869,29.3,24.784l.006,13.517.2.2a8.812,8.812,0,0,1,3.011,6.158l0,10.026a9.2,9.2,0,0,1-3.906,7.465l-.238.18-.08.242a41.982,41.982,0,0,1-11.655,17.737l-.195.18v8.107a6.992,6.992,0,0,0,4.2,5.981L472.2,514.96c7.815,3.785,12.73,11.226,12.71,19.361v2.3A5.234,5.234,0,0,1,479.541,541.654Z",
    transform: "translate(72.168 5.873)",
    fill: "#2f4265"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.1a916a7fbfe8b892e235e7d55bb80dff.svg";
export { ForwardRef as ReactComponent };